import request_index from "../index";
import { getUsessionId } from '@/utils-khfw/usession.service.js';
async function request(params){
    let uid = await getUsessionId();
    if(params.data){
        params.data = {
            ...params.data,
            loginPlatformCode: sessionStorage.getItem("loginPlatformCode"),
            platformCode: sessionStorage.getItem("platformCode"),
            usessionid: uid,
        }
    }
    return request_index(params);
};
// ===============机构===========
//获取课程信息列表
export function handleInstitutionList(data) {
    return request({
        url:'/assbe/course/institution/list',
        method: "post",
        data,
    });
}
//新增课程信息
export function addCurriculum(data) {
    return request({
        url:'/assbe/course/institution/add',
        method: "post",
        data,
    });
}
//获取课程详细信息 
export function getDetail(params) {
    return request({
        url:'/assbe/course/education/detail',
        method: "get",
        params,
    });
}
//课程送审
export function submitaudit(data) {
    return request({
        url:'/assbe/course/institution/submitaudit',
        method: "post",
        data,
    });
}

//课程上下架
export function handleStandupanddown(data) {
    return request({
        url:'/assbe/course/institution/standupanddown',
        method: "post",
        data,
    });
}
//课程删除
export function handleDelete(data) {
    return request({
        url:'/assbe/course/institution/delete',
        method: "post",
        data,
    });
}
//课程修改
export function handleUpdate(data) {
    return request({
        url:'/assbe/course/institution/update',
        method: "post",
        data,
    });
}
// ===============材料管理===========
//查询材料列表 
export function handleMaterialsList(data) {
    return request({
        url:'/assbe/materials/institution/list',
        method: "post",
        data,
    });
}
//材料修改 
export function handleMaterialsUpdate(data) {
    return request({
        url:'/assbe/materials/institution/update',
        method: "post",
        data,
    });
}
//材料新增 
export function handleMaterialsAdd(data) {
    return request({
        url:'/assbe/materials/institution/add',
        method: "post",
        data,
    });
}
//材料提交审核 
export function materialsSubmitaudit(data) {
    return request({
        url:'/assbe/materials/institution/submitaudit',
        method: "post",
        data,
    });
}
//材料详细
export function  handleMaterialsDetail(params) {
    return request({
        url:'/assbe/materials/education/detail',
        method: "get",
        params,
    });
}
//材料删除
export function  handleMaterialsDelete(data) {
    return request({
        url:'/assbe/materials/education/delete',
        method: "post",
        data,
    });
}
//获取材料审核列表信息
export function getAuditrecordList(params) {
    return request({
        url:'/assbe/materials/education/auditrecord',
        method: "get",
        params,
    });
}
//查询机构创建课程列表 
export function getOrgCourseList(id) {
    return request({
        url:`/assbe/materials/institution/coureslist?orgId=${id}`,
        method: "get",
    });
}
//查询机构创建课程列表 
export function getMaterialsList(id) {
    return request({
        url:`/assbe/course/institution/materials?orgId=${id}`,
        method: "get",
    });
}

//机构商户查询 
export function queryWechatMer(data) {
    return request({
        url:'assbe/qdoneApplyment/queryWechatMer',
        method: "post",
        data
    });
}
//查询支付渠道开通状态
export function queryPayChannelStatus(data) {
    return request({
        url:'assbe/qdoneApplyment/queryPayChannelStatus',
        method: "post",
        data
    });
}
//机构商户创建(微信)
export function createWechatMer(data) {
    return request({
        url:'assbe/qdoneApplyment/createWechatMer',
        method: "post",
        data
    });
}
//机构商户创建(支付宝)
export function createALiPayMer(data) {
    return request({
        url:'assbe/qdoneApplyment/createALiPayMer',
        method: "post",
        data
    });
}
//支付宝商户类别树形菜单
export function getMccCategoryTreeList(){
    return request({
        url:'assbe/qdoneApplyment/mccCategoryTreeList',
        method: "get",
    });
}


// 机构
const mechanismApi={
    // 机构-课程评价管理
    getEnterpriseCourseEvaluateList(data) {
        return request({
          url: `/assbe/courseevaluate/enterprise/search`,
          method: "post",
          data,
        })
    },
    //机构-查询订单列表
    handleEnterpriseList(data) {
        return request({
            url:'/assbe/order/enterprise/list',
            method: "POST",
            data,
        });
    },
    //机构-查询退费单列表
    getOrderEnterpriseRefunds(data) {
        return request({
            url:'/assbe/order/enterprise/refunds',
            method: "POST",
            data,
        });
    },
}

export default mechanismApi;
